import { render, staticRenderFns } from "./inquiryEditor.vue?vue&type=template&id=8cb405b6&"
import script from "./inquiryEditor.vue?vue&type=script&lang=js&"
export * from "./inquiryEditor.vue?vue&type=script&lang=js&"
import style0 from "./inquiryEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports